import React, { useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import withRedirectToLogin from './withRedirectToLogin';

const Page401 = () => {
   const history = useHistory();

   const handleClickReturn = useCallback((event) => {
      if (history && history.goBack) {
         history.goBack();
      }
   }, []);

   return (
      <div className='text-center absolute-center'>
         <h1 className='display-1 font-weight-bold'>401</h1>
         <p className='h1'>Unauthorized.</p>
         <p className='h2 font-weight-normal mt-3 mb-4'>
            You are not authorized to view this page.
         </p>
         <Link to='/'>
            <Button
               className='btn btn-dark-orange shadow-sm btn-rounded'
               size='lg'
               onClick={handleClickReturn}
            >
               Return
            </Button>
         </Link>
      </div>
   );
};

export default withRedirectToLogin(Page401);
